<template>
  <SecondaryCard class="email">
    <h4 class="section-header">Email</h4>
    <label class="section-subheader">
      At this time, scheduled reports can only be sent to
      the email currently logged into your MikMak account.
    </label>
    <BadgeBlock
      v-model="emailRecipients"
      label="Email Recipients"
      :class="`text-input no-border ${emailLabelClass}`"
    >
      <template v-slot:after>
        <TextInput
          :required="!emailRecipients.length"
          :disabled="true"
          v-model="newEmailAddress"
          name="email-recipients"
          label=""
          class="text-input no-border"
          @focus="listenForInputKeys"
          @blur="removeInputKeyListener"
        ></TextInput>
      </template>
    </BadgeBlock>
    <TextInput
      :required="!value.emailSubject"
      :value="value.emailSubject"
      label="Subject"
      name="email-subject"
      class="text-input"
      @input="handleSubjectInput"
    ></TextInput>
    <Select
      v-if="shouldShowFlaggedFeatures"
      :value="''"
      :disabled="true"
      label="Customize body message (optional)"
      name="email-body"
      :options="[]"
      @input="handleBodyMessageInput"
      class="dropdown-input"
    ></Select>
  </SecondaryCard>
</template>

<script>
import {
  SecondaryCard,
  TextInput,
  Select,
  BadgeBlock,
} from '@mikmak/components';
import utils from '../../../../services/utils';

export default {
  components: {
    SecondaryCard,
    TextInput,
    Select,
    BadgeBlock,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    currentUserEmail: {
      type: String,
      default: '',
    },
    setError: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    // const emailRecipients = (this.value.createdByEmail)
    //   ? [this.value.createdByEmail]
    //   : [this.currentUserEmail];
    const emailRecipients = [this.currentUserEmail];

    return {
      shouldShowFlaggedFeatures: false,
      newEmailAddress: '',
      isEmailInputFocused: '',
      emailValidationError: 'Please write a valid email format (ie. dio@awesome.com).',
      emailRecipients,
    };
  },
  methods: {
    handleSubjectInput(newVal) {
      this.value.emailSubject = newVal;
    },
    handleBodyMessageInput(newVal) {
      this.value.bodyMessage = newVal;
    },
    handleEmailInput(evt) {
      if (!evt.target.value) return;

      const emailCreatorKeys = [13, 32, 9]; // Space or Enter

      if (!evt.keyCode || emailCreatorKeys.indexOf(evt.keyCode) > -1) {
        const newEmail = evt.target.value;

        if (!utils.validateEmail(newEmail)) {
          setTimeout(() => this.setError(''), 3000);

          return this.setError(this.emailValidationError);
        }

        evt.target.value = '';
        this.newEmailAddress = '';

        this.value.emailRecipients.push(newEmail);
      }
    },
    listenForInputKeys() {
      this.isEmailInputFocused = true;

      document.addEventListener('keyup', this.handleEmailInput);
    },
    removeInputKeyListener(value) {
      this.isEmailInputFocused = false;

      this.handleEmailInput({ target: { value } });

      document.removeEventListener('keyup', this.handleEmailInput);
    },
  },
  computed: {
    emailLabelClass() {
      const newValue = (
        this.isEmailInputFocused ||
        this.emailRecipients.length ||
        this.newEmailAddress
      )
        ? 'with-values'
        : '';

      return newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.email ::v-deep {
  .section-header {
    margin: 0;
    color: #223448;
    margin-bottom: 10px;
  }

  .section-subheader {
    display: block;
    font-size: 12px;
    margin: 6px 0;
  }

  .text-input,
  .dropdown-input {
    margin: 10px 0;
  }

  .block-wrapper .block-content {
    display: flex;
    align-items: center;
    padding: 0;
    overflow: hidden;
  }

  .text-input.no-border {
    height: 58px;
  }

  .text-input.no-border.wrapper {
    margin: 0;
  }

  .text-input.no-border input {
    border: none;
    background: none;
    width: 100%;
    height: 3em;
    margin-top: 12px;
  }

  .block-content .badge-wrapper .primary {
    color: #4369F4;
    white-space: nowrap;
    margin-top: 15px;
    width: 100%;
  }

  .block-wrapper label {
    color: #778699;
    position: absolute;
    left: 52px;
    pointer-events: none;
    transform: translate(0, 100%);
    transition: 0.25s ease;
  }

  .text-input:last-of-type {
    margin-bottom: 0;
  }

  .text-input.no-border.with-values {
    position: relative;
  }

  .text-input.no-border.with-values label {
    font-size: 12px;
    line-height: 14px;
    transform: translate(-45%, 40%);
  }

  .badge-icon {
    display: none;
  }

  .badge-wrapper.focused {
    border: none;
    padding-left: 4px;
  }

  .email-disclaimer {
    display: block;
    border: solid red;
  }
}
</style>
